import { Trash } from "@phosphor-icons/react";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerDescription,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";
import type { IntegrationSettings } from "common/types";

import useIntegrationMutations from "../datahooks/useIntegrationMutations";

export default function RemoveIntegration({
  type,
}: {
  type: keyof IntegrationSettings;
}) {
  const isDesktop = useTwBreakpoint("lg");

  const { removeIntegration, isRemovingIntegration } =
    useIntegrationMutations();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Trigger = isDesktop ? DialogTrigger : DrawerTrigger;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <Component>
      <Trigger asChild>
        <Button
          variant={isDesktop ? "link-danger" : "ghost-danger"}
          size={isDesktop ? "sm" : "md"}
          className="self-end"
          leftIcon={<Trash />}
        >
          Remove <span className="capitalize">{type}</span>
        </Button>
      </Trigger>

      <Content className="lg:w-[448px]">
        <Title>Remove integration?</Title>
        <Description className="mb-8">
          Are you sure you want to remove{" "}
          <span className="text-sm-bold capitalize text-black-950">{type}</span>{" "}
          integration from the workspace?
        </Description>

        <div className="flex items-center justify-between gap-x-2.5">
          <Close asChild>
            <Button
              className="lg:flex-1"
              variant="secondary-black"
              disabled={isRemovingIntegration}
            >
              Cancel
            </Button>
          </Close>
          <Button
            className="lg:flex-1"
            variant="outline-danger"
            onClick={() => removeIntegration(type)}
            isLoading={isRemovingIntegration}
          >
            Remove
          </Button>
        </div>
      </Content>
    </Component>
  );
}
